import { Facebook, LinkedCameraTwoTone, LinkedIn, Twitter } from "@mui/icons-material";
import { Alert, Box, Button, Container, IconButton, Snackbar, Stack, TextField, Typography } from "@mui/material";
import Link from '@mui/material/Link';
import { AppIcon } from "./app-icon";
import { useState } from "react";

  
function Copyright() {
    return (
        <Typography variant="body2" color="inherit" mt={1}>
            {'Copyright © '}
            <Link color="inherit">
                NutriEdu
            </Link>
            {' '}
            {new Date().getFullYear()}
            {' | All rights reserved.'}
        </Typography>
    );
}

function FooterPage(){
    const [email, setEmail] = useState('');

    const handleChange = (e) => {    
        setEmail(e.target.value);
    };

    const [responseM, setResponseM] = useState({
        'message': '',
        'severity': ''
    });
    
    const handleClose = () => {
        setResponseM({
            'message' : '',
            'severity': ''
        })
    }

    const subscribe = async (e) => {        
        e.preventDefault();

        try {
            const response = await fetch('https://nutriedu.com.ng/api/v1/join-newsletter.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({email})
            });

            const data = await response.json();
            if (data.success) {
                setEmail('');
                setResponseM({
                    message: 'subscribed successfully',
                    severity: 'success'
                });
            }
            else {
                setResponseM(({
                    message: 'error subscribing',
                    severity: 'error'
                }));
            }
            
        } catch (error) {
            setResponseM(({
                message: error.message,
                severity: 'error'
            }));
        }
    };

    return(
        <Box
            id="footer"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: {xs: 4, sx: 8},
                marginTop: 5,
                textAlign: { sm: 'center', md: 'left' },
            }}  
        >

            <Container
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    flexDirection: 'column'
                }}
            >
                <Typography
                    sx={{
                        fontFamily: 'Fredoka One, sans-serif',
                        color: 'grey.800',
                        marginBottom: '20px',
                        fontSize: '1.7rem',
                    }}
                >
                    Newsletter
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: { xs: '100%', sm: '60%' },
                    }}
                >
                    
                    <Box sx={{ xs: '100%', sm: '60%'}}>
                        <Typography variant="body2" color="text.secondary" mb={2}>
                            Subscribe to our newsletter to get notified when we release a new feature or publish a new article.
                        </Typography>
                        <Stack direction='row' spacing={1} useFlexGap>
                            
                            <TextField
                                id="email"
                                name="email"
                                hiddenLabel
                                value={email}
                                size="small"
                                variant="outlined"
                                fullWidth
                                aria-label="Enter your email address"
                                placeholder="Your email address"
                                inputProps={{
                                    autoComplete: 'off',
                                    'aria-label': 'Enter your email address',
                                }}
                                onChange={handleChange}
                            />

                            <Button variant="contained" sx={{ flexShrink: 0, backgroundColor: "#0d610d" }}
                                onClick={subscribe}>
                                Subscribe
                            </Button>

                        </Stack>
                    </Box>
                </Box>
            </Container>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    px: { xs: 2, sm: 4 },
                    py: 3,
                    width: '100%',
                    backgroundColor: 'grey.900',
                    color: 'white',
                }}
            >
                <Copyright />
            </Box>

            {
                responseM['message'] && 

                <Snackbar
                    open={true}
                    autoHideDuration={5000}
                    onClose={handleClose}
                >
                    <Alert
                        onClose={handleClose}
                        severity={responseM['severity']}
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {responseM['message']}
                    </Alert>
                </Snackbar>
            }

        </Box>
    )
};

export default FooterPage;